/**
 * Return a shallow copy of an object with specified keys removed
 * - Same as lodash .omit but accepts multiple keys to emit
 */
export default function (src: Object, ...omit: Array) {
  const dest = {};
  const omitMap = {};
  omit.forEach(key => omitMap[key] = true);

  for (let key in src) if (src.hasOwnProperty(key)) {
    if (!omitMap[key]) {
      dest[key] = src[key];
    }
  }

  return dest;
}



// WEBPACK FOOTER //
// ./~/virgo/src/utils/omit.js